export const PassRules = [
    `No mínimo 8 caracteres`,
    `No máximo 20 caracteres`,
    `Conter letras, números e caracteres especiais`,
    `Não deve conter mais de 3 números sequenciais`,
    `Não deve conter mais de 3 números repetidos em ordem`,
    `Não ser igual ao CPF, CNPJ, data de nascimento, telefone ou celular`,
]